import trackerHelper from "@coworker/app/src/helpers/tracker";
import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import { FilterValue, MultiSelectFilter } from "../../types/filter";
import { TrackingProps } from "../../types/component";
import { getFilterValueCount } from "../../utils/filter/filtervalue";

interface InputMultiSelectPillMobileProps {
  filter: MultiSelectFilter;
  filterValues: FilterValue[];
  onTriggerFilter: (filterId: string) => void;
  tracking: TrackingProps;
}

export const InputMultiSelectPillMobile = ({
  filter,
  filterValues,
  onTriggerFilter,
  tracking,
}: InputMultiSelectPillMobileProps) => {
  const { id, title } = filter;

  return (
    <FixaPill
      id={`fixapill-${id}`}
      data-testid={`fixapill-${id}`}
      label={title}
      onClick={() => {
        trackerHelper.filter.trackFilterRowClicked(
          tracking.feature,
          tracking.mode,
          filter.id
        );
        onTriggerFilter(id);
      }}
      size="small"
      selected={!!getFilterValueCount(filter, filterValues)}
    />
  );
};
